<template>
	<div class="hello" @click="defaul">
		<div class="aside">
			<div class="logo">雀巢消费者服务中心</div>
			<el-menu
				:default-active="$route.path"
				class="el-menu-vertical-demo"
				@open="handleOpen"
				@close="handleClose"
				router
			>
				<template v-for="(item, index) in nav_list">
					<!--无子菜单-->
					<el-menu-item :index="item.route" :class="item.class2">
						<i :class="item.class"></i>
						<span slot="title">{{ item.message }}</span>
					</el-menu-item>
				</template>
			</el-menu>
		</div>

		<div class="main-content-wrapper">
			<header class="header">
				<div class="g-header">
					<div class="manage cursor" @click.stop="quit">
						<i class="iconfont icon-manage"></i>
						<span v-if="users.roleId==2">超级管理员</span>
						<span v-else-if="users.roleId==4">审计管理员</span>
						<i class="iconfont icon-down"></i>
						<ul
							class="dropdown-menu animated fadeInDown"
							v-if="show"
						>
					 
							<li @click="quitSignIn">
								<a id="quit">退出</a>
							</li>
						</ul>
					</div>
					<div class="work cursor"  v-if="users.roleId==2">
						<router-link to="/customs/talks">
							<i class="iconfont icon-work"></i>
							<span>客服工作台</span>
						</router-link>
					</div>
				</div>
			</header>
			<router-view />
		</div>
	</div>
</template>

<script>
import { SignarStart } from '@/utils/utilsSignar'
export default {
	name: 'HelloWorld',

	data() {
		return {
			show: false,
			nav_list: [],
			users:{}
		}
	},
	mounted: function () {
		let arr = 
		[
			{
				route: '/manage/staff',
				message: '员工',
				class: 'iconfont icon-yuangong',
			},
			{
				route: '/manage/custom',
				message: '客户',
				class: 'iconfont icon-kehu',
			},
			{
				route: '/manage/system',
				message: '在线系统',
				class: 'iconfont icon-system',
			},
			{
				route: '/manage/setting',
				message: '系统设置',
				class: 'iconfont icon-setting',
			}
		]
		 let json = window.localStorage.getItem('USER_INFO')
		let obj = json != null ? JSON.parse(json) : null;
		if(obj.roleId==2){
			arr.push({
					route:'/manage/auditList',
					message: '审计管理',
					class:'iconfont icon-setting'
				})
			this.nav_list=arr;
		}else{
			this.nav_list.push({
					route:'/manage/auditList',
					message: '审计管理',
					class:'iconfont icon-setting'
				})
		}

		this.users=obj
		SignarStart()
	},
	created: function(){
	
	},
	methods: {
		quit(data) {
			if (this.show) {
				this.show = false
			} else {
				this.show = true
			}
		},
		defaul(data) {
			this.show = false
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath)
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath)
		},
		quitSignIn(str) {
			let loginModel = JSON.parse(localStorage.getItem(this.LoginInfo))
			let $this = this
			this.axios
				.get('Login', {
					params: { state: str },
				})
				.then(function ({ data }) {
					if (str == undefined) {
						// $this.updateDuration()
						$this.$message.success('退出成功')
					}
					localStorage.clear()
					$this.$router.push({ path: '/login' })
				})
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html {
	font-size: 62.5%;
}
body,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
form,
fieldset,
legend,
button,
input,
textarea,
th,
td {
	margin: 0;
	padding: 0;
	vertical-align: baseline;
}
.clear {
	clear: both;
}
.logo {
	position: relative;
	width: 150px;
	height: 60px;
	padding: 0;
	font-size: 16px;
	text-align: center;
	color: #fff;
	line-height: 60px;
	background-color: #337eff;
}

.el-menu {
	background-color: transparent;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
	width: 150px;
	position: absolute;
}
.el-menu-item {
	color: #a8adaf;
}
.el-menu-item.is-active {
	color: #fff;
	border-right: 3px #4d70ff solid;
	background-color: #000;
}

.hello {
	height: 100%;
	width: 100%;
	display: -webkit-box;
	display: -ms-flexbox;
	/* display: flex; */
	-webkit-box-orient: horizontal;
	-webkit-box-direction: normal;
}
.aside {
	position: relative;
	transition: width 0.1s linear;
	width: 150px;
	background-color: rgba(0, 0, 0, 0.87);
	height: 100%;
}
.el-menu-item:focus,
.el-menu-item:hover {
	background-color: #000;
	color: #fff;
}
/*header*/
.header {
	height: 60px;
	line-height: 60px;
	display: -webkit-box;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	flex-direction: column;
	background-color: #fff;
	border-bottom: 1px solid #e1e3e6;
}
.main-content-wrapper {
	display: -webkit-box;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	flex-direction: column;
	-webkit-box-flex: 1;
	flex: auto;
}
.g-header {
	display: block;
	display: -webkit-box;
	display: flex;
	-webkit-box-align: center;
	align-items: center;
	align-content: center;
	flex-direction: row-reverse;
}
.work {
	margin-right: 30px;
}
.manage {
	margin-right: 50px;
	position: relative;
}
.dropdown-menu {
	width: 96px;
	position: absolute;
	padding: 6px 26px;
	background-color: #fff;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	-webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	-moz-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	-o-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	border: 1px solid rgba(0, 0, 0, 0.15);
	list-style: none;
	top: 65px;
	right: 0;
	border-radius: 3px;
}
.dropdown-menu:before {
	position: absolute;
	right: 41px;
	top: -5px;
	content: '';
	z-index: 1;
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-bottom: 6px solid #fff;
}
.dropdown-menu li {
	line-height: 40px;
}
.fadeInDown {
	-webkit-animation-name: fadeInDown;
	animation-name: fadeInDown;
}
.animated {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
}

@keyframes fadeInDown {
	0% {
		opacity: 0;
		-webkit-transform: translateY(-20px);
		-ms-transform: translateY(-20px);
		transform: translateY(-20px);
	}

	100% {
		opacity: 1;
		-webkit-transform: translateY(0);
		-ms-transform: translateY(0);
		transform: translateY(0);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/manage/baseManage/baseManage.vue